import { render, staticRenderFns } from "./pontosDeEntrega.vue?vue&type=template&id=763100d2"
import script from "./pontosDeEntrega.vue?vue&type=script&lang=js"
export * from "./pontosDeEntrega.vue?vue&type=script&lang=js"
import style0 from "./pontosDeEntrega.vue?vue&type=style&index=0&id=763100d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports